// extracted by mini-css-extract-plugin
export default {"container":"PolicyPage_container__J+Z48","contentWrapper":"PolicyPage_contentWrapper__WW+A3","title":"PolicyPage_title__JHBav","content":"PolicyPage_content__MLPoZ"};